import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTE_META, DEFAULT_META, SITE_ORIGIN } from './routeMeta'

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector)
  if (el) el.setAttribute(attr, value)
}

// Keeps title/description/canonical/OG tags in sync with the current route.
// The prerender pass snapshots the DOM after this runs, so each static route
// ships with its own head. Mounted once inside <Router>.
const Seo = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const meta = ROUTE_META[pathname] || DEFAULT_META
    const canonical = SITE_ORIGIN + (process.env.PUBLIC_URL + (pathname === '/' ? '' : pathname) || '/')

    document.title = meta.title
    setMeta('meta[name="description"]', 'content', meta.description)
    setMeta('link[rel="canonical"]', 'href', canonical)
    setMeta('meta[property="og:title"]', 'content', meta.title)
    setMeta('meta[property="og:description"]', 'content', meta.description)
    setMeta('meta[property="og:url"]', 'content', canonical)
    setMeta('meta[name="twitter:title"]', 'content', meta.title)
    setMeta('meta[name="twitter:description"]', 'content', meta.description)
  }, [pathname])

  return null
}

export default Seo
